/**
  Action function that initializes the reader analytics store
*/
export const initializeReaderAnalyticsData = (
  chapterID,
  pageID,
  pageLoadDate,
  analyticsData,
) => {
  return {
    type: 'INITIALIZE_ANALYTICS_STORE',
    chapterID: chapterID,
    pageID: pageID,
    pageLoadDate: pageLoadDate,
    analyticsData: analyticsData,
  }
}

/**
  Action function that toggles the flag notifying whether or not there is new analytic data available
*/
export const toggleAnalyticsUpdated = isAnalyticsUpdated => {
  return {
    type: 'TOGGLE_ANALYTICS_UPDATED',
    payload: isAnalyticsUpdated,
  }
}

/**
  Action function that updates the previousAnalyticsData to reflect the previous state of analyticsData
*/
export const updatePreviousAnalyticsData = previousAnalyticsData => {
  return {
    type: 'UPDATE_PREVIOUS_ANALYTICS_DATA',
    payload: previousAnalyticsData,
  }
}

/**
  Action function that updates the analyticsData with reading analytics
*/
export const updateReadingAnalyticsData = (paragraphID, value) => {
  return {
    type: 'UPDATE_READING_ANALYTICS_DATA',
    paragraphID: paragraphID,
    value: value,
  }
}

/**
  Action function that updates the analyticsData with video analytics
*/
export const updateVideoAnalyticsData = (fileref, statsList) => {
  return {
    type: 'UPDATE_VIDEO_ANALYTICS_DATA',
    fileref: fileref,
    statsList: statsList,
  }
}


/**
  Action function that updates the analyticsData caliper analytics
*/
export const addCaliperData = (fileref, caliperList) => ({
  type: 'ADD_CALIPER_DATA',
  fileref: fileref,
  caliperAnalytics: caliperList
});

/**
  Action function that updates the analyticsData caliper analytics
*/
export const removeCaliperData = () => ({
  type: 'REMOVE_CALIPER_DATA'
});
